const accountNavbarI18n = {
  "fr": {
    "links": {
      "transactions": "Transactions",
      "account": "Compte"
    },
    "logout": "Déconnexion",
    "logoutAria": "Se déconnecter"
  },
  "en": {
    "links": {
      "transactions": "Transactions",
      "account": "Profilo"
    },
    "logout": "Log out",
    "logoutAria": "Log out"
  },
  "pl": {
    "links": {
      "transactions": "Transakcje",
      "account": "Konto"
    },
    "logout": "Wyloguj",
    "logoutAria": "Wyloguj"
  },
  "es": {
    "links": {
      "transactions": "Transacciones",
      "account": "Cuenta"
    },
    "logout": "Cerrar sesión",
    "logoutAria": "Cerrar sesión"
  },
  "it": {
    "links": {
      "transactions": "Transazioni",
      "account": "Account"
    },
    "logout": "Accedi",
    "logoutAria": "Accedi"
  },
  "de": {
    "links": {
      "transactions": "Transaktionen",
      "account": "Konto"
    },
    "logout": "Abmelden",
    "logoutAria": "Abmelden"
  },
  "pt": {
    "links": {
      "transactions": "Operações",
      "account": "Profilo"
    },
    "logout": "Sair",
    "logoutAria": "Sair"
  },
  "cs": {
    "links": {
      "transactions": "Transakce",
      "account": "Profilo"
    },
    "logout": "Odhlásit se",
    "logoutAria": "Odhlásit se"
  },
  "nl": {
    "links": {
      "transactions": "Transacties",
      "account": "Profilo"
    },
    "logout": "Afmelden",
    "logoutAria": "Afmelden"
  }
};

export default accountNavbarI18n;
